import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { FuturePurchaseFollowupNote } from "src/models/FuturePurchase.model";

import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";

type Props = {
  formikProps: FormikProps<FuturePurchaseFollowupNote>;
  onClose: () => void;
};

const FollowupForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Status of Future Purchase</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="note"
            value={values.note}
            required
            onChange={(e) => {
              setFieldValue("note", e.target.value);
            }}
            label="Future Purchase note"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMCheckbox
            name="nextfollowupNoteRequired"
            label="Next Followup Required"
            checked={values.nextfollowupNoteRequired}
            value={values.nextfollowupNoteRequired.toString()}
            onChange={(checked) =>
              setFieldValue("nextfollowupNoteRequired", checked)
            }
          />
        </div>
        {values.nextfollowupNoteRequired && (
          <div>
            <ATMDatePicker
              label=" Date of Purchase"
              name="nextfollowupNoteDate"
              format="DD/MM/YYYY"
              minDate={moment().format("yyyy-MM-DD")}
              value={values.nextfollowupNoteDate || null}
              onChange={(newValue) =>
                setFieldValue(
                  "nextfollowupNoteDate",
                  moment(newValue)?.format("yyyy-MM-DD")
                )
              }
            />
          </div>
        )}
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default FollowupForm;
